import React from 'react';
import { Mail } from 'lucide-react';
export function SubscriptionForm() {
  return <div className="border-t-4 border-ink bg-white p-6 shadow-sm" data-id="element-109">
      <div className="flex items-center justify-center mb-4 text-accent" data-id="element-110">
        <Mail className="w-8 h-8" data-id="element-111" />
      </div>
      <h3 className="text-xl text-center mb-2 font-serif font-bold uppercase tracking-wider" data-id="element-112">
        The Daily Brief
      </h3>
      <p className="text-center text-ink-light text-sm italic mb-6 font-body" data-id="element-113">
        Essential news, expert analysis, and exclusive content delivered
        straight to your inbox every morning.
      </p>

      <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-114">
        <div data-id="element-115">
          <label htmlFor="email" className="sr-only" data-id="element-116">
            Email address
          </label>
          <input type="email" id="email" placeholder="Your email address" className="w-full px-4 py-3 bg-paper border border-gray-300 focus:border-ink focus:ring-1 focus:ring-ink outline-none transition-all font-body text-sm placeholder:text-gray-500" required data-id="element-117" />
        </div>
        <button type="submit" className="w-full bg-ink text-paper py-3 px-4 font-serif font-bold uppercase tracking-widest text-xs hover:bg-accent transition-colors duration-300" data-id="element-118">
          Subscribe
        </button>
      </form>
      <p className="text-center text-xs text-gray-400 mt-4 font-body" data-id="element-119">
        Join 50,000+ subscribers. Unsubscribe anytime.
      </p>
    </div>;
}